import React from "react";
import Aboutus from "../Components/about/Aboutus";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";
import useSEO from "../seo/useSEO";

function AboutusPage() {
  useSEO({
    title: "Hakkımızda | Aypin Otomat",
    description:
      "Aypin Otomat hakkında bilgi edinin. Bursa Nilüfer'de CNC kayar otomat, talaşlı imalat ve özel parça üretimi alanındaki üretim yaklaşımımızı inceleyin.",
    path: "/hakkimizda",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Hakkımızda",
        path: "/hakkimizda",
      },
    ],
  });

  return (
    <>
      <TopBar />
      <Spacer2 />
      <Aboutus isPage={true} />
    </>
  );
}

export default AboutusPage;